"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replyWithCounts = void 0;
/**
 *
 * data is output form prisma.aggregate with _count: { [by]: true}
 *
 * @param by
 * @param data
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function replyWithCounts(by, data) {
    const counts = {};
    data.forEach((item) => {
        // eslint-disable-next-line security/detect-object-injection
        counts[item[by]] = item._count[by];
    });
    return {
        counts,
    };
}
exports.replyWithCounts = replyWithCounts;
